import {
  ContentfulBlocks,
  type QueryAllBlocksRecursivelyResult,
} from '@dreamstack/accentro-contentful'
import {
  GridWithGaps,
  GridWithGapsNoCols,
} from '@dreamstack/feature-components'
import { RatingArrow } from '@dreamstack/icons'
import type { FunctionComponent } from 'react'
import tw, { styled } from 'twin.macro'

const StyledRatingArrow = styled(RatingArrow)(() => [
  tw`text-accentroGray-100 height[342px] width[342px] lg:(height[368px] width[368px])`,
  tw`transform -translate-x-px-80 md:(transform-none absolute top-0 right[32px]) ml:(right[56px])`,
])

const AnalystRatingWrapper = styled(GridWithGapsNoCols)(() => [
  tw`grid-cols-1 col-span-full pb-px-96 gap-y-px-48 order-1`,
  tw`md:(grid-cols-2 col-start-5 col-end-13 gap-y-px-96 order-2) `,
  tw`ml:(grid-cols-3 col-start-2 col-end-13) `,
])

const AnalystRatings: FunctionComponent<React.PropsWithChildren<{
  blocks: QueryAllBlocksRecursivelyResult[]
}>> = ({ blocks }) => {
  return (
    <GridWithGaps>
      <div tw="order-2 md:(order-1 col-span-4) ml:(col-span-1) relative">
        <StyledRatingArrow />
      </div>
      <AnalystRatingWrapper>
        <ContentfulBlocks blocks={blocks} />
      </AnalystRatingWrapper>
    </GridWithGaps>
  )
}

export default AnalystRatings
